import './assets/base.css'
import './style.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { FontAwesomeIcon } from './plugins/fontawesome'
import { createI18n } from 'vue-i18n'

import App from './App.vue'
import router from './router'

const i18n = createI18n({
    legacy: false,
    locale: 'zh',
    messages: {
        zh: {
            Common: {
                yes: '是',
                no: '否',
                pleaseConfirm: '请确认',
                create: '创建',
                cancel: '取消',
                confirm: '确认',
                update: '更新',
            },
            AI: {
                reGenerateAnswerPrompt: '确定要重新生成答案吗？'
            },
            Login: {
                login: '登录',
                phonePlaceholder: '请输入手机号',
                passwordPlaceholder: '请输入密码',
                loginBtn: '登录',
                signUpBtn: '注册',
                signInBtn: '登录',
                signInPrompt: '已有账号？',

            }
        }
    }
})

const app = createApp(App)

app.component('font-awesome-icon', FontAwesomeIcon)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)

app.use(router)
app.use(i18n)

app.mount('#app')
